/**
 * Search row: search input, exact match, tablet filters entry, and export report control.
 */
import "./rma-list-main-toolbar.scss";
import { observer } from "mobx-react";
import SearchBar from "../../../../../components/layouts/search-bar/search-bar";
import SearchInput from "../../../../../components/search-input/search-input";
import { Toggle } from "../../../../../components/inputs/toggle/toggle";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../../dashboard-translation/stores/dashboard-translations-store";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import RmaListExportReport from "../rma-list-export-report/rma-list-export-report";
import rmaPagedListStore from "../../../rma-list-page/stores/rma-paged-list-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    isLoading: boolean;
    onSearchClick: () => void;
    onSearchInputChange: (value: string) => void;
    onSearchExactMatchChange: () => void;
    onTabletFiltersOpen: () => void;
}

const RmaListMainToolbar: React.FC<IProps> = observer(
    ({
        rmaListFiltersStore,
        isLoading,
        onSearchClick,
        onSearchInputChange,
        onSearchExactMatchChange,
        onTabletFiltersOpen,
    }) => {
        const { getTranslation } = useDashboardTranslation();
        const scope = "dashboard-returns-page";

        return (
            <div className="rma-list-main-toolbar">
                <SearchBar>
                    <SearchInput
                        placeholder={getTranslation("SEARCH_FIELD_PLACEHOLDER", scope)}
                        value={rmaListFiltersStore.searchInput ?? ""}
                        onClick={onSearchClick}
                        onChange={onSearchInputChange}
                    />
                    <Toggle
                        disabled={isLoading}
                        checked={rmaListFiltersStore.searchExactMatch}
                        label={getTranslation("EXACT_MATCH", scope)}
                        onChange={onSearchExactMatchChange}
                    />
                    {!dashboardTranslationsStore.isLoading && (
                        <div className="rma-list-main-toolbar__tablet-filters">
                            <Button
                                variant={BUTTON_VARIANTS.Text}
                                text={getTranslation("FILTERS_TITLE", scope)}
                                onClick={() => {
                                    rmsMixpanelStore.trackEvent("d&_filters_button");
                                    onTabletFiltersOpen();
                                }}
                            />
                        </div>
                    )}
                    <div className="rma-list-main-toolbar__end">
                        {!dashboardTranslationsStore.isLoading && (
                            <RmaListExportReport
                                getReportFilters={rmaPagedListStore.rmaListFiltersStore.getReportFilters}
                            />
                        )}
                    </div>
                </SearchBar>
            </div>
        );
    },
);

export default RmaListMainToolbar;
